









import * as echarts from 'echarts';
import ResizeMixin from '@/components/Charts/mixins/resize';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'specialtyDistributionBar',
})
export default class extends Mixins(ResizeMixin) {
  @Prop({ default: 'bar-chart' }) public className!: string;
  @Prop({ default: '404px' }) public height!: string;
  @Prop({ default: () => ({}) }) public data!: any;
  @Prop({ default: () => [] }) public xAxisData!: any;

  get year() {
    return UserModule.indexSelectYear;
  }

  get language() {
    return AppModule.language;
  }

  public chart: any = null;
  public xAxis: any = [];
  public legendDataType: any[] = [];
  public valueConfigs: any[] = [];

  @Watch('language')
  @Watch('year')
  @Watch('data', { deep: true })
  public watchNum(val: any) {
    if (!this.chart) {
      this.initChart();
    }
    if (this.chart && (val === null || val === undefined || val === '')) {
      this.chart.clear();
    } else {
      const seriesData = this.getSeriesData();
      this.setEchartsOptions(seriesData);
    }
  }

  public mounted() {
    this.$nextTick(() => {
      this.initChart();
      const seriesData = this.getSeriesData();
      this.setEchartsOptions(seriesData);
    })
  }

  public beforeDestroy() {
    if (!this.chart) {
      return;
    }
    // 销毁实例，实例销毁后无法再被使用
    this.chart.dispose();
    this.chart = null;
  }

  public getSeriesData() {
    return this.data.applyNums;
  }

  public initChart() {
    const barChartDom = this.$refs.barChartSpecialty;
    this.chart = echarts.init(barChartDom as HTMLDivElement);
  }

  public setEchartsOptions(seriesData: any) {
    this.chart.setOption({
      tooltip: {
        trigger: 'axis',
        formatter: (params: any, ticket: any, callback: any) => {
          const a = params
            .filter((_: any) => _.name)
            .map((_: any) => `<span style="display: inline-block;background-color: ${_.color};width: 10px;height:10px;border-radius: 50%;margin-right:6px"></span>${_.name}：${_.value}`)
          return `<span>${a}</span>`;
        },
      },
      grid: {
        top: '20',
        bottom: '30'
      },
      yAxis: {
        show: true,
        type: 'value',
      },
      xAxis: {
        type: 'category',
        data: this.xAxisData,
        axisLabel: { show: false },
        // axisLabel: { interval: 0, rotate: 68 }
      },
      series: [
        {
          type: 'bar',
          data: seriesData,
          itemStyle: {
            normal: {
              // 定制显示（按顺序）
              color: (params: any) => {
                const colorList = ['#50E3C2','#53B997','#6750AA','#F8C541','#294680', '#73B4F8','#7A4388','#E883B9','#00827F','#FF9B47','#386DF1','#999A9F','#B450E3','#D7E350','#616A6B','#EAF2F8','#4A235A','#3498DB' ];
                return colorList[params.dataIndex]
              }
            },
          },
        }
      ]
    }, {replaceMerge: ['series']});
    // this.chart.on('click', (params: any) => {
    //   const month = params.dataIndex;
    //   const year = this.year;
    //   if (year !== '0') {
    //     const endTime = `${year}-${month + 1}-${new Date(Number(year), (month + 1), 0).getDate()}`;
    //     const startTime = `${year}-${(month + 1)}-1`
    //     this.$router.push({ name: 'applicationList', query: { startTime: startTime.toString(), endTime: endTime.toString() } })
    //   } else {
    //     this.$message.warning(this.$t('message.businessOverviewMessage') as string);
    //   }
    // });
  }
}
